<form novalidate [formGroup]="form" class="bank-card-form">
  <input
    type="text"
    formControlName="name"
    placeholder="Jane Doe"
    [ngClass]="{
      invalid: form.get('name').invalid && form.get('name').touched
    }"
  />
  <ngx-stripe-card
    [options]="cardOptions"
    [elementsOptions]="elementsOptions"
  ></ngx-stripe-card>
</form>
